if (!customElements.get('m-country-search')) {
  class MCountrySearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-country-search]');
      this.options = this.querySelectorAll('[data-country-option]');
      this.empty = this.querySelector('[data-country-search-empty]');
      this.divider = this.querySelector('[data-country-divider]');
      this.customSelect = this.closest('.js-selectCustom');
      this.form = this.closest('form');
      if (!this.input) return;

      this.onInput = this.filter.bind(this);
      this.onPointer = this.keepOpen.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onTriggerClick = this.handleTriggerClick.bind(this);
      this.onSubmit = this.handleSubmit.bind(this);

      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('click', this.onPointer);
      this.input.addEventListener('mousedown', this.onPointer);
      this.input.addEventListener('keydown', this.onKeydown);
      this.querySelector('.m-country-search__field')?.addEventListener('click', this.onPointer);
      this.customSelect?.querySelector('.m-select-custom--trigger')?.addEventListener('click', this.onTriggerClick);
      this.form?.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('click', this.onPointer);
      this.input?.removeEventListener('mousedown', this.onPointer);
      this.input?.removeEventListener('keydown', this.onKeydown);
      this.customSelect?.querySelector('.m-select-custom--trigger')?.removeEventListener('click', this.onTriggerClick);
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    keepOpen(event) {
      event.stopPropagation();
    }

    handleSubmit(event) {
      if (document.activeElement === this.input) event.preventDefault();
    }

    handleKeydown(event) {
      event.stopPropagation();
      if (event.key === 'Enter') event.preventDefault();
      if (event.key === 'Escape') {
        this.reset();
        this.customSelect?.classList.remove('isActive');
        this.input.blur();
      }
    }

    handleTriggerClick() {
      requestAnimationFrame(() => {
        if (!this.customSelect?.classList.contains('isActive')) {
          this.reset();
          return;
        }
        this.reset();
        this.input.focus();
      });
    }

    reset() {
      if (!this.input.value) return;
      this.input.value = '';
      this.filter();
    }

    filter() {
      const query = this.input.value.trim().toLowerCase();
      let visible = 0;
      let featuredVisible = 0;

      this.options.forEach((option) => {
        const text = (option.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        const iso = (option.getAttribute('data-value') || '').toLowerCase();
        const match = !query || text.includes(query) || iso.includes(query);
        option.hidden = !match;
        if (match) {
          visible += 1;
          if (option.hasAttribute('data-featured')) featuredVisible += 1;
        }
      });

      if (this.divider) this.divider.hidden = Boolean(query) || featuredVisible === 0;
      if (this.empty) this.empty.hidden = visible > 0;
    }
  }

  customElements.define('m-country-search', MCountrySearch);
}
